var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Inject, Injectable } from "@angular/core";
import { EncryptStorage } from "../..";
import { Model } from "../model";
import { Events } from "ionic-angular";
import { StorageData } from "../../storage/storage-data";
import { CheckUtils } from "../../index";
var UsersModel = /** @class */ (function (_super) {
    __extends(UsersModel, _super);
    function UsersModel(storage, events) {
        var _this = _super.call(this, storage, events, "user") || this;
        _this._sequenceUserId = -3;
        _this._sequenceUserIdKey = "_sequence-user-id";
        _this.event.SEQUENCE_USER_ID_LOADED = _this._sequenceUserIdKey + ":loaded";
        _this.event.SEQUENCE_USER_ID_CHANGED = _this._sequenceUserIdKey + ":changed";
        return _this;
    }
    UsersModel.prototype.extraLoadEncryptData = function () {
        var _this = this;
        this.storage.load(this._sequenceUserIdKey).then(function (_sequenceUserId) {
            if (!CheckUtils.isEmpty(_sequenceUserId) && typeof _sequenceUserId != 'string') {
                _this._sequenceUserId = _sequenceUserId;
            }
            _this.events.publish(_this.event.SEQUENCE_USER_ID_LOADED);
        });
    };
    Object.defineProperty(UsersModel.prototype, "event", {
        get: function () {
            return this._event;
        },
        enumerable: true,
        configurable: true
    });
    UsersModel.prototype.nextUserId = function (preventDefault) {
        this._sequenceUserId--;
        var storageData = new StorageData(this.event.SEQUENCE_USER_ID_CHANGED, preventDefault, this._sequenceUserId);
        storageData.key = this._sequenceUserIdKey;
        storageData.item = this._sequenceUserId;
        this.storage.saveAs(storageData);
        return this._sequenceUserId;
    };
    UsersModel.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    UsersModel.ctorParameters = function () { return [
        { type: EncryptStorage, decorators: [{ type: Inject, args: [EncryptStorage,] },] },
        { type: Events, decorators: [{ type: Inject, args: [Events,] },] },
    ]; };
    return UsersModel;
}(Model));
export { UsersModel };
//# sourceMappingURL=users-model.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/models/user/users-model.js
// module id = 248
// module chunks = 14